import { render, staticRenderFns } from "./BudgetCategoryCard.vue?vue&type=template&id=6a379720&scoped=true"
import script from "./BudgetCategoryCard.vue?vue&type=script&lang=js"
export * from "./BudgetCategoryCard.vue?vue&type=script&lang=js"
import style0 from "./BudgetCategoryCard.vue?vue&type=style&index=0&id=6a379720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a379720",
  null
  
)

export default component.exports